module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//7.jpg?dcfd00ed0ca91ffe48ef5c800aa76b75";